export default __webpack_public_path__ + "static/media/qbeyond.b02017e0.svg";